import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { catchError, of, switchMap } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    constructor() { }

    ngOnInit() {
        //this.authService.handleRedirectObservable().pipe(
        //    catchError(_ => {
        //        console.log('Error: ', _);
        //        return of(console.error('Redirect Error: ', _.errorMessage))
        //    })
        //).subscribe();

        // this.authService.setLogger(
        //     new Logger(
        //         (logLevel, message, piiEnabled) => {
        //             console.log('MSAL Logging: ', message);
        //         },
        //         {
        //             correlationId: CryptoUtils.createNewGuid(),
        //             piiLoggingEnabled: false,
        //         }
        //     )
        // );
    }
}
